import Hero from "@/components/home/Hero";
import WhatAreYouBuilding from "@/components/home/WhatAreYouBuilding";
import RecognitionSlider from "@/components/home/RecognitionSlider";
import Services from "@/components/home/Services";
import TechStack from "@/components/home/TechStack";
import Industries from "@/components/home/Industries";
import WhatsLatest from "@/components/home/WhatsLatest";
import Clients from "@/components/home/Clients";
import TeamPreview from "@/components/home/TeamPreview";
import BlogTeaser from "@/components/home/BlogTeaser";
import ReviewsScroller from "@/components/home/ReviewsScroller";
import VideoShowcase from "@/components/home/VideoShowcase";
import Seo from "@/components/seo/Seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Custom Software, AI & Mobile App Development for Growing Businesses"
        description="CloudLab Technologies designs and develops custom CRM systems, AI-powered business applications, mobile apps and enterprise software for organisations across the UK, Pakistan and international markets."
        keywords="custom software development UK, custom CRM development, mobile app development, AI development, business process automation, software modernisation, staff augmentation, cloud DevOps, software company Glasgow, enterprise AI"
      />
      <Hero />
      <WhatAreYouBuilding />
      <RecognitionSlider />
      <Services />
      <TechStack />
      <Industries />
      <VideoShowcase />
      <WhatsLatest />
      <Clients />
      <TeamPreview />
      <BlogTeaser />
      <ReviewsScroller />
    </div>
  );
}
